import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { addPlayerNameToSetup } from '../../../../logic/setup/setup';

function SinglesSetup(props: { game: string }) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Control
                type="text"
                placeholder={t('general.home_player')}
                style={{ fontSize: '24px' }}
                onChange={(val) => addPlayerNameToSetup(props.game, val.target.value, 'home')}
            />
            <Form.Control
                type="text"
                placeholder={t('general.guest_player')}
                style={{ marginTop: '12px', fontSize: '24px' }}
                onChange={(val) => addPlayerNameToSetup(props.game, val.target.value, 'guest')}
            />
        </>
    );
}

export default SinglesSetup;
